/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import colors from '@sportninja/common/constants/appColors'
import HeaderActionButton from 'src/components/ActionButton/HeaderActionButton'
import { balanceLabel, balanceText } from '../utils/balanceI18n'

type BalanceEmptyStateProps = {
  onSetUp: () => void
}

/**
 * Zero-slot sheet state. The FirstRunModal is dismissible, so the page behind
 * it must offer a way back into the set-up flow — without this, a dismissed
 * modal was only recoverable by reloading the page.
 */
const BalanceEmptyState = ({ onSetUp }: BalanceEmptyStateProps) => (
  <div
    data-testid='balance-empty-state'
    css={css`
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 12px;
      padding: 48px 24px;
      border-radius: 8px;
      background: ${colors.SECONDARY_500};
    `}
  >
    <span
      css={css`
        width: 40px;
        height: 40px;
        border-radius: 50%;
        border: 1px dashed ${colors.NEUTRAL_400};
      `}
    />
    <span
      css={css`
        color: ${colors.NEUTRAL_100};
        text-align: center;
      `}
    >
      {balanceText('common:balanceEmptyNoSlots')}
    </span>
    {/* antd `Button type='primary' ghost` before — the third distinct button
        implementation on one screen, and the only one that rendered YELLOW label
        text on transparent. Same component and size as Add Player Slot and the
        first-run footer now, so the tab has one button language. */}
    <HeaderActionButton
      variant='secondary'
      size='small'
      textWeight='regular'
      onClick={onSetUp}
      text={balanceLabel('common:balanceEmptySetUp')}
      data-testid='balance-empty-setup'
    />
  </div>
)

export default BalanceEmptyState
